module.exports = __webpack_public_path__ + "static/media/rejected.a89cf683.svg";